import styled from "styled-components";
export const TotalCardRowWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: ${({ theme }) => theme?.utilities.spacing["space-lg"]};
`;
